<template>
    <div>
        <vc-left-menu></vc-left-menu>
        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title" v-if="this.modifyMode">{{ $t('words.channel_manage') }} <span class="page-header-breadcrumb">></span> {{ $t('words.edit_channel') }}</h3>
                    <h3 class="page-title" v-else>{{ $t('words.channel_manage') }} > {{ $t('words.create_channel') }}</h3>
                </div>
            </div>

            <div class="module">
                <div class="module-body">
                    <form role="form" method="POST" @submit.prevent="doSubmit">
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="key">{{ $t('words.key') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="key" name="key" disabled :class="{'form-control':true, 'is-invalid':meta.errors.key}" v-model="channel.key" />
                                <span class="invalid-feedback" v-if="meta.errors.key" v-for="error in meta.errors.key" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="title">{{ $t('words.channel_name') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="title" name="title" maxlength="80" :placeholder="$t('paragraphs.channel.placeholder_title')" :class="{'form-control':true, 'is-invalid':meta.errors.title}" v-model="channel.title" />
                                <span class="invalid-feedback" v-if="meta.errors.title" v-for="error in meta.errors.title" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="customer_code">{{ $t('words.customer_code') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="customer_code" name="customer_code" maxlength="32" :placeholder="$t('paragraphs.channel.placeholder_customer_code')" :class="{'form-control':true, 'is-invalid':meta.errors.customer_code}"  v-model="channel.customer_code" :disabled="isOnAir" />
                                <span class="invalid-feedback" v-if="meta.errors.customer_code" v-for="error in meta.errors.customer_code" :key="error">{{ error }}</span>
                            </div>
                            <div class="offset-md-3 col-md-9"><small class="form-text text-muted">{{ $t('paragraphs.channel.customer_code_tip') }}</small></div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="concurrently_viewer_limit">{{ $t('words.concurrently_viewer_limit') }}</label>
                            <div class="col-md-9">
                                <div v-if="useConcurrentlyViewerLimitPolicy">
                                    <select id="concurrently_viewer_limit" :class="{'custom-select':true, 'col-md-3':true, 'is-invalid':meta.errors.concurrently_viewer_limit}" v-model="channel.concurrently_viewer_limit" :disabled="isOnAir"  >
                                        <option v-for="value in concurrently_viewer_limits" :key="value" :value="value"
                                                v-if="(!(value===-100 && !haveKollusAdminRight && channel.concurrently_viewer_limit !== -100))" :disabled="value===-100 && !haveKollusAdminRight">
                                            <span v-if="value===-100">{{ $t('words.use_no') }}</span>
                                            <span v-else-if="value===0">{{ $t('words.no_limit') }}</span>
                                            <span v-else>{{ value }}</span>
                                        </option>
                                    </select>
                                    <span class="invalid-feedback" v-if="meta.errors.concurrently_viewer_limit" v-for="error in meta.errors.concurrently_viewer_limit" :key="error">{{ error }}</span>
                                </div>
                                <div v-else>
                                    {{ $t('paragraphs.not_use_policy')}}
                                </div>
                            </div>
                            <div class="offset-md-3 col-md-9"><small class="form-text text-muted">{{ $t('paragraphs.channel.concurrently_view_limit_tip') }}</small></div>
                        </div>
                        <div class="form-group row" v-if="useFileToLive || useWebRtc || useCmaf">
                            <label class="col-md-3">{{ $t('words.channel_kind') }}</label>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <div class="form-radio">
                                        <input type="radio" name="kind" :value="0" :class="{'form-check-input':true, 'is-invalid':meta.errors.kind}" v-model="channel.kind" id="is_kind_general" :disabled="isOnAir || modifyMode" >
                                        <label for="is_kind_general">{{ $t('words.mnu_live') }}</label>
                                    </div>
                                    <div class="form-radio" v-if="useCmaf">
                                        <input type="radio" name="kind" :value="3" :class="{'form-check-input':true, 'is-invalid':meta.errors.kind}" v-model="channel.kind" id="is_kind_cmaf" :disabled="isOnAir || modifyMode">
                                        <label for="is_kind_cmaf">{{ $t('words.cmaf') }}</label><span class="text-tooltip v-tooltip-open" v-tooltip.bottom="{ content: $t('paragraphs.channel.cmaf_desc'), boundariesElement: 'window', classes: ['tooltip--long'] }"><i class="icon icon-info-circle-line"></i></span>
                                    </div>
                                    <div class="form-radio" v-if="useFileToLive">
                                        <input type="radio" name="kind" :value="1" :class="{'form-check-input':true, 'is-invalid':meta.errors.kind}" v-model="channel.kind" id="is_kind_programming" :disabled="isOnAir || modifyMode">
                                        <label for="is_kind_programming">{{ $t('words.programming_live') }}</label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="useWebRtc">
                                    <label class="form__subtitle">{{ $t('words.webrtc_channel') }}</label>
                                    <div class="form-radio">
                                        <input type="radio" name="kind" :value="2" :class="{'form-check-input':true, 'is-invalid':meta.errors.kind}" v-model="channel.kind" id="is_kind_webrtc" :disabled="isOnAir || modifyMode" >
                                        <label for="is_kind_webrtc">{{ $t('words.realtime_live') }}</label>
                                    </div>
                                </div>
                                <span class="invalid-feedback" v-if="meta.errors.kind" v-for="error in meta.errors.kind" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="media_profile_groups">{{ $t('words.media_profile_groups') }}</label>
                            <div class="col-md-9">
                                <select id="media_profile_groups" :class="{'custom-select':true, 'col-md-3':true, 'is-invalid':meta.errors.live_media_profile_group_id}" v-model="channel.live_media_profile_group_id" :disabled="isOnAir" >
                                    <option v-for="item in media_profile_groups" :key="item.id" :value="item.id" :disabled="disablePassThrough(item.profiles)">{{ item.name }}</option>
                                </select>
                                <a href="/preferences/profile_groups" target='_blank' class="btn btn-flat ml-md-2">{{ $t('words.go_detail') }}</a>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3">{{ $t('words.is_shared') }}</label>
                            <div class="col-md-9">
                                <div class="form-radio">
                                    <input type="radio" name="is_shared" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.is_shared}" v-model="channel.is_shared" id="is_shared_true" :disabled="isOnAir" >
                                    <label for="is_shared_true">{{ $t('words.open') }}</label>
                                </div>
                                <div class="form-radio">
                                    <input type="radio" name="is_shared" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.is_shared}" v-model="channel.is_shared" id="is_shared_false" :disabled="isOnAir" >
                                    <label for="is_shared_false">{{ $t('words.not_open') }}</label>
                                </div>
                                <span class="invalid-feedback" v-if="meta.errors.is_shared" v-for="error in meta.errors.is_shared" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="meta_title_pattern">{{ $t('words.meta_title_pattern') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="meta_title_pattern" name="meta_title_pattern" :class="{'form-control':true, 'is-invalid':meta.errors.meta_title_pattern}" v-model="channel.meta_title_pattern" />
                                <span class="invalid-feedback" v-if="meta.errors.meta_title_pattern" v-for="error in meta.errors.meta_title_pattern" :key="error">{{ error }}</span>
                                <div class="form-guide-box">
                                    <p class="form-guide"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.channel.meta_title_pattern.sample_desc') }}</p>
                                    <ul>
                                        <li>{{ $t('paragraphs.channel.meta_title_pattern.sample1') }}</li>
                                        <li>{{ $t('paragraphs.channel.meta_title_pattern.sample2') }}</li>
                                        <li>{{ $t('paragraphs.channel.meta_title_pattern.sample3') }}</li>
                                        <li>{{ $t('paragraphs.channel.meta_title_pattern.sample4') }}</li>
                                        <li v-if="programChannel">{{ $t('paragraphs.channel.meta_title_pattern.sample5') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="meta_description">{{ $t('words.meta_description') }}</label>
                            <div class="col-md-9">
                                <textarea id="meta_description" name="meta_description" rows="5" :class="{'form-control':true, 'is-invalid':meta.errors.meta_description}" v-model="channel.meta_description"></textarea>
                                <span class="invalid-feedback" v-if="meta.errors.meta_description" v-for="error in meta.errors.meta_description" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="generalChannel || webrtcChannel || cmafChannel">
                            <label class="col-md-3 col-form-label" for="recording_file_pattern">{{ $t('words.recording_file_pattern') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="recording_file_pattern" name="recording_file_pattern" :class="{'form-control':true, 'is-invalid':meta.errors.recording_file_pattern}" v-model="channel.recording_file_pattern" />
                                <span class="invalid-feedback" v-if="meta.errors.recording_file_pattern" v-for="error in meta.errors.recording_file_pattern" :key="error">{{ error }}</span>
                                <div class="form-guide-box">
                                    <p class="form-guide"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.channel.recording_file_pattern.tip') }}<br><span style="margin-left: 24px">{{ $t('paragraphs.channel.recording_file_pattern.sample_desc') }}</span></p>
                                    <ul>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample1') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample2') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample3') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample4') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample5') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample6') }}</li>
                                        <li>{{ $t('paragraphs.channel.recording_file_pattern.sample7') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="generalChannel || webrtcChannel || cmafChannel">
                            <label class="col-md-3">{{ $t('words.live_broadcast_policy') }}</label>
                            <div class="col-md-9">
                                <div>
                                    {{ $t('paragraphs.division_delayed_tip1') }}
                                    <select :class="{'custom-select':true, 'form__select--sm':true, 'is-invalid':meta.errors.division_delayed_minutes}"  v-model="channel.division_delayed_minutes" :disabled="isOnAir">
                                        <option v-for="value in division_delayed_minutes_limit" :key="value" :value="value">
                                            <span>{{ value }} {{ $t('words.unit_minute')}}</span>
                                        </option>
                                    </select>
                                    {{ $t('paragraphs.division_delayed_tip2') }}
                                </div>
                                <span class="invalid-feedback" v-if="meta.errors.division_delayed_minutes" v-for="error in meta.errors.division_delayed_minutes" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <hr class="form__divider" v-if="generalChannel || webrtcChannel || cmafChannel">
                        <div class="form-group row" v-if="generalChannel || webrtcChannel || cmafChannel">
                            <label class="col-md-3">{{ $t('words.recording_file_policy') }}</label>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <label class="form__subtitle">{{ $t('words.save_auto') }}</label>
                                    <div class="form-radio">
                                        <input type="radio" name="recording_file_policy_auto" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_policy}" v-model="recording_file_policy_auto" id="channel-recording_file_policy-save_auto_file_yes" :disabled="isOnAir" >
                                        <label for="channel-recording_file_policy-save_auto_file_yes">{{ $t('words.use_yes') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="recording_file_policy_auto" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_policy}" v-model="recording_file_policy_auto" id="channel-recording_file_policy-save_auto_file_no" :disabled="isOnAir" >
                                        <label for="channel-recording_file_policy-save_auto_file_no">{{ $t('words.use_no') }}</label>
                                    </div>
                                    <span class="invalid-feedback" v-if="meta.errors.recording_file_policy" v-for="error in meta.errors.recording_file_policy" :key="error">{{ error }}</span>
                                    <div class="form__box mt-sp">
                                        <div class="form-radio">
                                            <input type="radio" name="recording_file_segment_policy " :value="1" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_segment_policy}" v-model="channel.recording_file_segment_policy" id="channel-recording_file_segment_policy-1" :disabled="isOnAir || !recording_file_policy_auto" >
                                            <label for="channel-recording_file_segment_policy-1">{{ $t('words.save_maximum_volume')}}</label>
                                            <p class="form__description">{{ $t('paragraphs.recording_size_tip') }}</p>
                                        </div>
                                        <div class="form-radio">
                                            <input type="radio" name="recording_file_segment_policy " :value="2" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_segment_policy}" v-model="channel.recording_file_segment_policy" id="channel-recording_file_segment_policy-2" :disabled="isOnAir || !recording_file_policy_auto" >
                                            <label for="channel-recording_file_segment_policy-2">{{ $t('words.save_interval_time')}}</label>
                                            <div class="form__description">
                                                {{ $t('paragraphs.recording_duration_tip1') }}
                                                <select :class="{'custom-select':true, 'form__select--sm':true, 'is-invalid':meta.errors.recording_file_segment_by_duration}"  v-model="channel.recording_file_segment_by_duration" :disabled="channel.recording_file_segment_policy!==2 || !recording_file_policy_auto ||isOnAir">
                                                    <option v-for="value in recording_file_segment_by_duration_limit" :key="value" :value="value">
                                                        <span>{{ value }} {{ $t('words.unit_minute')}}</span>
                                                    </option>
                                                </select>
                                                {{ $t('paragraphs.recording_duration_tip2') }}
                                            </div>
                                        </div>
                                        <span class="invalid-feedback" v-if="meta.errors.recording_file_segment_policy" v-for="error in meta.errors.recording_file_segment_policy" :key="error">{{ error }}</span>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group" style="margin-bottom: 0">
                                        <label class="form__subtitle">{{ $t('words.save_manual') }}</label>
                                        <div>
                                            <div class="form-radio">
                                                <input type="radio" name="recording_file_policy_manual" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_policy}" v-model="recording_file_policy_manual" id="channel-recording_file_policy-save_manual_file_yes" :disabled="isOnAir" >
                                                <label for="channel-recording_file_policy-save_manual_file_yes">{{ $t('words.use_yes') }}</label>
                                            </div>
                                            <div class="form-radio">
                                                <input type="radio" name="recording_file_policy_manual" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.recording_file_policy}" v-model="recording_file_policy_manual" id="channel-recording_file_policy-save_manual_file_no" :disabled="isOnAir" >
                                                <label for="channel-recording_file_policy-save_manual_file_no">{{ $t('words.use_no') }}</label>
                                            </div>
                                            <span class="invalid-feedback" v-if="meta.errors.recording_file_policy" v-for="error in meta.errors.recording_file_policy" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="form__divider" v-if="!webrtcChannel">
                        <div class="form-group row" v-if="!webrtcChannel">
                            <label class="col-md-3">{{ $t('words.use_aes128') }}</label>
                            <div class="col-md-9">
                                <div v-show="isCmafChannel">{{  $t('paragraphs.channel.aes128_disabled_desc') }}</div>
                                <div v-show="useAES128 && !isCmafChannel">
                                    <div class="form-radio">
                                        <input type="radio" name="use_aes128" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_aes128}" v-model="channel.use_aes128" id="channel-use-aes128-yes" :disabled="isOnAir || !haveKollusAdminRight" >
                                        <label for="channel-use-aes128-yes">{{ $t('words.use_yes') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="use_aes128" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_aes128}" v-model="channel.use_aes128" id="channel-use-aes128-no" :disabled="isOnAir || !haveKollusAdminRight" >
                                        <label for="channel-use-aes128-no">{{ $t('words.use_no') }}</label>
                                    </div>
                                    <span class="invalid-feedback" v-if="meta.errors.use_aes128" v-for="error in meta.errors.use_aes128" :key="error">{{ error }}</span>
                                </div>
                                <div v-show="!useAES128" v-html="supportMailHtml" />
                            </div>
                        </div>
                        <div class="form-group row" v-if="useThirdPartyDrmPolicy && !webrtcChannel">
                            <label class="col-md-3">{{ $t('words.multi_drm') }}</label>
                            <div class="col-md-9">
                                <div class="form-radio">
                                    <input type="radio" name="use_third_party_drm" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_third_party_drm}" v-model="channel.use_third_party_drm" id="channel-use-third_party_drm-yes" :disabled="isOnAir || isCmafChannel || isMultiDrmDisabled">
                                    <label for="channel-use-third_party_drm-yes">{{ $t('words.use_yes') }}</label>
                                </div>
                                <div class="form-radio">
                                    <input type="radio" name="use_third_party_drm" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_third_party_drm}" v-model="channel.use_third_party_drm" id="channel-use-third_party_drm-no" :disabled="isOnAir || isCmafChannel || isMultiDrmDisabled">
                                    <label for="channel-use-third_party_drm-no">{{ $t('words.use_no') }}</label>
                                </div>
                                <span class="invalid-feedback" v-if="meta.errors.use_third_party_drm" v-for="error in meta.errors.use_third_party_drm" :key="error">{{ error }}</span>

                                <div class="form__box mt-sp" v-if="!webrtcChannel">
                                    <label class="text-help" style="font-weight: 700;">{{ $t('words.widevine_revoked_device') }}</label>
                                    <div class="form-radio">
                                        <input type="radio" name="widevine_revoked_device_play" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.widevine_revoked_device_play}" v-model="channel.widevine_revoked_device_play" id="channel-widevine-revoked-device-play-yes" :disabled="isOnAir || !isMultiDrmUsed" >
                                        <label for="channel-widevine-revoked-device-play-yes">{{ $t('words.allow_play') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="widevine_revoked_device_play" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.widevine_revoked_device_play}" v-model="channel.widevine_revoked_device_play" id="channel-widevine-revoked-device-play-no" :disabled="isOnAir || !isMultiDrmUsed" >
                                        <label for="channel-widevine-revoked-device-play-no">{{ $t('words.block_play') }}</label>
                                    </div>
                                    <span class="invalid-feedback" v-if="meta.errors.widevine_revoked_device_play" v-for="error in meta.errors.widevine_revoked_device_play" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="!webrtcChannel">
                            <label class="col-md-3">{{ $t('words.use_exclusive_player') }}</label>
                            <div class="col-md-9">
                                <div v-show="useExclusivePlayerPolicy">
                                    <div class="form-radio">
                                        <input type="radio" name="media_player_policy" value="0" :class="{'form-check-input':true, 'is-invalid':meta.errors.media_player_policy}" v-model.number="channel.media_player_policy" id="channel-media_player_policy_none" :disabled="isOnAir" >
                                        <label for="channel-media_player_policy_none">{{ $t('words.media_player_policy_none') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="media_player_policy" value="1" :class="{'form-check-input':true, 'is-invalid':meta.errors.media_player_policy}" v-model.number="channel.media_player_policy" id="channel-media_player_policy_only" :disabled="isOnAir" >
                                        <label for="channel-media_player_policy_only">{{ $t('words.media_player_policy_only') }}</label>
                                    </div>
                                    <!--<div class="form-radio">-->
                                    <!--<input type="radio" name="media_player_policy" :value="2" :class="{'form-check-input':true, 'is-invalid':meta.errors.media_player_policy}" v-model.number="channel.media_player_policy" id="channel-media_player_policy_only_at_mobile" :disabled="isOnAir" >-->
                                    <!--<label for="channel-media_player_policy_only_at_mobile">{{ $t('words.media_player_policy_only_at_mobile') }}</label>-->
                                    <!--</div>-->
                                    <span class="invalid-feedback" v-if="meta.errors.media_player_policy" v-for="error in meta.errors.media_player_policy" :key="error">{{ error }}</span>
                                </div>
                                <div v-show="!useExclusivePlayerPolicy">
                                    {{ $t('paragraphs.not_use_policy')}}
                                </div>

                                <div class="form__box mt-sp">
                                    <label class="text-help" style="font-weight: 700;">{{ $t('words.use_capture_block') }}</label>
                                    <div v-if="captureBlockPolicyInfo === 'teruten'">
                                    {{ $t('paragraphs.use_capture_block_policy')}}
                                    </div>
                                    <div v-else-if="captureBlockPolicyInfo === 'no'">
                                        {{ $t('paragraphs.not_use_policy')}}
                                    </div>
                                    <div v-else>
                                        <div class="form-radio">
                                            <input type="radio" name="use_capture_block" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_capture_block, 'form__guide--disabled': isOnAir || isCaptureBlockDisabled}" v-model="channel.use_capture_block" id="channel-use-capture_block-yes" :disabled="isOnAir || isCaptureBlockDisabled" >
                                            <label for="channel-use-capture_block-yes">{{ $t('words.use_yes') }}</label>
                                        </div>
                                        <div class="form-radio">
                                            <input type="radio" name="use_capture_block" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_capture_block, 'form__guide--disabled': isOnAir || isCaptureBlockDisabled}" v-model="channel.use_capture_block" id="channel-use-capture_block-no" :disabled="isOnAir || isCaptureBlockDisabled" >
                                            <label for="channel-use-capture_block-no">{{ $t('words.use_no') }}</label>
                                        </div>
                                        <span class="invalid-feedback" v-if="meta.errors.use_capture_block" v-for="error in meta.errors.use_capture_block" :key="error">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="!webrtcChannel">
                            <label class="col-md-3">{{ $t('words.use_duplicate_block') }}</label>
                            <div class="col-md-9">
                                <div v-show="useDuplicateBlockPolicy">
                                    <div class="form-radio">
                                        <input type="radio" name="use_duplicate_block" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_duplicate_block}" v-model="channel.use_duplicate_block" id="channel.use_duplicate_block-yes" :disabled="isOnAir" >
                                        <label for="channel.use_duplicate_block-yes">{{ $t('words.use_yes') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="use_duplicate_block" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_duplicate_block}" v-model="channel.use_duplicate_block" id="channel.use_duplicate_block-no" :disabled="isOnAir" >
                                        <label for="channel.use_duplicate_block-no">{{ $t('words.use_no') }}</label>
                                    </div>
                                    <span class="invalid-feedback" v-if="meta.errors.use_duplicate_block" v-for="error in meta.errors.use_duplicate_block" :key="error">{{ error }}</span>
                                </div>
                                <div v-show="!useDuplicateBlockPolicy">
                                    {{ $t('paragraphs.not_use_policy')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3">{{ $t('words.block_external_output_display') }}</label>
                            <div class="col-md-9">
                                <div style="padding-bottom: 16px;">
                                    {{ $t('paragraphs.block_external_output_display_desc')}}
                                </div>
                                <div>
                                    <div class="form-radio">
                                        <input type="radio" name="disable_tvout" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.disable_tvout}" v-model="channel.disable_tvout" id="channel.disable_tvout-yes" :disabled="isOnAir" >
                                        <label for="channel.disable_tvout-yes">{{ $t('words.use_yes') }}</label>
                                    </div>
                                    <div class="form-radio">
                                        <input type="radio" name="disable_tvout" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.disable_tvout}" v-model="channel.disable_tvout" id="channel.disable_tvout-no" :disabled="isOnAir" >
                                        <label for="channel.disable_tvout-no">{{ $t('words.use_no') }}</label>
                                    </div>
                                    <span class="invalid-feedback" v-if="meta.errors.disable_tvout" v-for="error in meta.errors.disable_tvout" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- TODO TIMESHIFT POLICY -->
                        <div class="form-group row" v-if="useTimeShiftPolicy && !webrtcChannel">
                            <label class="col-md-3">{{ $t('words.use_timeshift') }}</label>
                            <div class="col-md-9">
                                <div class="form-radio">
                                    <input type="radio" :value="true" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_timeshift}" v-model="channel.use_timeshift" id="channel-use-timeshift-yes" :disabled="isCmafChannel">
                                    <label for="channel-use-timeshift-yes">{{ $t('words.use_yes') }}</label>
                                </div>
                                <div class="form-radio">
                                    <input type="radio" :value="false" :class="{'form-check-input':true, 'is-invalid':meta.errors.use_timeshift}" v-model="channel.use_timeshift" id="channel-use-timeshift-no" :disabled="isCmafChannel">
                                    <label for="channel-use-timeshift-no">{{ $t('words.use_no') }}</label>
                                </div>
                            </div>
                            <span class="invalid-feedback" v-if="meta.errors.use_timeshift" v-for="error in meta.errors.use_timeshift" :key="error">{{ error }}</span>
                        </div>
                        <hr class="form__divider" v-if="haveKollusAdminRight && !webrtcChannel">
                        <div class="form-group row" v-if="haveKollusAdminRight && !webrtcChannel">
                            <label class="col-md-3">{{ $t('words.latency_time_config') }}</label>
                            <div class="col-md-9" style="display: flex; gap: 16px; flex-direction: column">
                                <div class="col-md row">
                                    <div class="col-md">
                                        <label for="max_age">{{ $t('words.max_age') }}</label>
                                        <div class="input-group">
                                            <input type="text" id="max_age" name="max_age" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.max_age, 'text-md-right':true}" v-model="channel.max_age" :disabled="isOnAir" @input="channel.max_age = checkDigitOnly($event.target.value)" />
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_second') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.max_age" v-for="error in meta.errors.max_age" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <label for="chunk_duration">{{ $t('words.chunk_duration') }}</label>
                                        <div v-if="isCmafChannel" class="input-group">
                                            <input type="text" id="chunk_duration" name="chunk_duration" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_duration_cmaf, 'text-md-right':true}"  v-model="channel.chunk_duration_cmaf" :disabled="isOnAir" @input="channel.chunk_duration_cmaf = checkDigitOnlyAndNotZero($event.target.value)"/>
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_millisecond') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_duration_cmaf" v-for="error in meta.errors.chunk_duration_cmaf" :key="error">{{ error }}</span>
                                        </div>
                                        <div v-else class="input-group">
                                            <input type="text" id="chunk_duration" name="chunk_duration" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_duration, 'text-md-right':true}"  v-model="channel.chunk_duration" :disabled="isOnAir" @input="channel.chunk_duration = checkDigitOnlyAndNotZero($event.target.value)"/>
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_millisecond') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_duration" v-for="error in meta.errors.chunk_duration" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <label for="chunk_count">{{ $t('words.chunk_count') }}</label>
                                        <div v-if="isCmafChannel" class="input-group">
                                            <input type="text" id="chunk_count" name="chunk_count" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_count_cmaf, 'text-md-right':true}" v-model="channel.chunk_count_cmaf" :disabled="isOnAir" @input="channel.chunk_count_cmaf = checkDigitOnlyAndNotZero($event.target.value)" />
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_quantity') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_count_cmaf" v-for="error in meta.errors.chunk_count_cmaf" :key="error">{{ error }}</span>
                                        </div>
                                        <div v-else class="input-group">
                                            <input type="text" id="chunk_count" name="chunk_count" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_count, 'text-md-right':true}" v-model="channel.chunk_count" :disabled="isOnAir" @input="channel.chunk_count = checkDigitOnlyAndNotZero($event.target.value)" />
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_quantity') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_count" v-for="error in meta.errors.chunk_count" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md" v-if="isCmafChannel">
                                        <label for="chunk_part_duration_cmaf">{{ $t('words.chunk_part_duration_cmaf') }}</label>
                                        <div class="input-group">
                                            <input type="text" id="chunk_part_duration_cmaf" name="chunk_part_duration_cmaf" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_part_duration_cmaf, 'text-md-right':true}" v-model="channel.chunk_part_duration_cmaf" :disabled="isOnAir" @input="channel.chunk_part_duration_cmaf = checkDigitOnlyAndNotZero($event.target.value)" />
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_millisecond') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_part_duration_cmaf" v-for="error in meta.errors.chunk_part_duration_cmaf" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md row" v-if="isCmafChannel">
                                    <div class="col-md fc-more-cell">
                                        <label class="text-help">{{ $t('words.channel_low_latency_hls') }}</label><span class="text-tooltip v-tooltip-open" v-tooltip.bottom="{ content: $t('paragraphs.channel.low_latency_hls_desc'), boundariesElement: 'window', classes: ['tooltip--long'] }"><i class="icon icon-info-circle-line"></i></span>
                                    </div>
                                    <div class="col-md">
                                        <label for="chunk_duration">{{ $t('words.chunk_duration') }}</label>
                                        <div class="input-group">
                                            <input type="text" id="chunk_duration" name="chunk_duration" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_duration, 'text-md-right':true}"  v-model="channel.chunk_duration" :disabled="isOnAir" @input="channel.chunk_duration = checkDigitOnlyAndNotZero($event.target.value)"/>
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_millisecond') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_duration" v-for="error in meta.errors.chunk_duration" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <label for="chunk_count">{{ $t('words.chunk_count') }}</label>
                                        <div class="input-group">
                                            <input type="text" id="chunk_count" name="chunk_count" maxlength="5" :class="{'form-control':true, 'is-invalid':meta.errors.chunk_count, 'text-md-right':true}" v-model="channel.chunk_count" :disabled="isOnAir" @input="channel.chunk_count = checkDigitOnlyAndNotZero($event.target.value)" />
                                            <div class="input-group-append"><span class="form-control input-group-text">{{ $t('words.unit_quantity') }}</span></div>
                                            <span class="invalid-feedback" v-if="meta.errors.chunk_count" v-for="error in meta.errors.chunk_count" :key="error">{{ error }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="module-footer">
                    <router-link :to="{ name: 'cms-channels-list' }" class="btn btn-lg btn-danger">
                        {{ $t('words.cancel') }}
                    </router-link>
                    <button type="submit" class="btn btn-lg btn-primary" v-if="haveSubmitRight" @click.prevent="doSubmit">
                        {{ $t('words.save') }}
                    </button>
                </div>
            </div>

            <div class="module">
                <div class="module-header-tab">
                    <ul class="nav nav-tab" id="childTab" role="tablist">
                        <li class="nav-item">
                            <!-- active된 탭이 중복발생(vue에서 동적바인딩한 active클래스 속성에 의한 탭 활성화, 부트스트랩에서 부여된 active클래스에 의한 탭 활성화)하게 되어 주석처리함.   -->
                            <!--                            <a :class="{'nav-link':true, 'active': generalChannel}" id="creater-nav" data-toggle="tab" href="#creater-tab" role="tab" aria-controls="creator" aria-selected="false"  v-show="generalChannel">{{ $t('words.creator_code') }}</a>-->
                            <a :class="{'nav-link':true, 'active': (currentTab === 'creator')}" id="creater-nav" data-toggle="tab" href="#creater-tab" role="tab" aria-controls="creator" aria-selected="false"  v-show="generalChannel || webrtcChannel || cmafChannel" @click="currentTab='creator'">{{ $t('words.creator_code') }}</a>
                        </li>
                        <li class="nav-item">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'file_transfer')}" id="file_transfer-nav" data-toggle="tab" href="#file_transfer-tab" role="tab" aria-controls="file_transfer" aria-selected="false" v-show="generalChannel || webrtcChannel || cmafChannel" @click="currentTab='file_transfer'">{{ $t('words.recording_file_transfer')}}</a>
                        </li>
                        <li class="nav-item">
                            <!--                            <a :class="{'nav-link':true, 'active': programChannel}" id="syndication-nav" data-toggle="tab" href="#syndication-tab" role="tab" aria-controls="syndication" aria-selected="false">{{ $t('words.syndication') }}</a>-->
                            <a :class="{'nav-link':true, 'active': (currentTab === 'syndication')}" id="syndication-nav" data-toggle="tab" href="#syndication-tab" role="tab" aria-controls="syndication" aria-selected="false"  @click="currentTab='syndication'">{{ $t('words.syndication') }}</a>
                        </li>
                        <li class="nav-item">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'country_restriction')}" id="country_restriction-nav" data-toggle="tab" href="#country_restriction-tab" role="tab" aria-controls="country_restriction" aria-selected="false" @click="currentTab='country_restriction'">{{ $t('words.country_restriction') }}</a>
                        </li>
                        <li class="nav-item">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'decoration')}" id="decoration-nav" data-toggle="tab" href="#decoration-tab" role="tab" aria-controls="decoration" aria-selected="false" @click="currentTab='decoration'">{{ $t('words.decoration') }}</a>
                        </li>
                        <li class="nav-item">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'callback')}" id="callback-nav" data-toggle="tab" href="#callback-tab" role="tab" aria-controls="callback" aria-selected="false" @click="currentTab='callback'">{{ $t('words.callback') }}</a>
                        </li>
                        <li class="nav-item" v-if="chattingAvailable">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'chatting')}" id="chatting-nav" data-toggle="tab" href="#chatting-tab" role="tab" aria-controls="chatting" aria-selected="false" @click="currentTab='chatting'">{{ $t('words.chatting') }}</a>
                        </li>
                        <li class="nav-item">
                            <a :class="{'nav-link':true, 'active': (currentTab === 'referer')}" id="referer-nav" data-toggle="tab" href="#referer-tab" role="tab" aria-controls="referer" aria-selected="false" @click="currentTab='referer'">{{ $t('words.referer_config') }}</a>
                        </li>
                    </ul>
                </div>
                <div class="module-body">
                    <div class="tab-content">
                        <!--                        <div :class="{'tab-pane':true, 'active': generalChannel}" id="creater-tab" role="tabpanel" aria-labelledby="creator-tab" v-show="generalChannel">-->
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'creator')}" id="creater-tab" role="tabpanel" aria-labelledby="creator-tab" v-show="generalChannel || webrtcChannel || cmafChannel">
                            <tab-creator :channel="channel" :modifyMode="modifyMode" :currentTab="currentTab"></tab-creator>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'file_transfer')}" id="file_transfer-tab" role="tabpanel" aria-labelledby="file_transfer-tab" v-show="generalChannel || webrtcChannel || cmafChannel">
                            <tab-file_transfer  :channel="channel" :modifyMode="modifyMode"  :currentTab="currentTab"></tab-file_transfer>
                        </div>
                        <!--                        <div :class="{'tab-pane':true, 'active': programChannel}" id="syndication-tab" role="tabpanel" aria-labelledby="syndication-tab">-->
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'syndication')}" id="syndication-tab" role="tabpanel" aria-labelledby="syndication-tab">
                            <tab-syndication  :channel="channel" :modifyMode="modifyMode" :currentTab="currentTab"></tab-syndication>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'country_restriction')}"  id="country_restriction-tab" role="tabpanel" aria-labelledby="country_restriction-tab">
                            <tab-country_restriction  :channel="channel" :modifyMode="modifyMode" :currentTab="currentTab"></tab-country_restriction>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'decoration')}"  id="decoration-tab" role="tabpanel" aria-labelledby="decoration-tab">
                            <tab-decoration :channel="channel" :modifyMode="modifyMode" :currentTab="currentTab"></tab-decoration>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'callback')}"  id="callback-tab" role="tabpanel" aria-labelledby="callback-tab">
                            <tab-callback :channel="channel" :modifyMode="modifyMode" :generalChannel="generalChannel" :webrtcChannel="webrtcChannel" :cmafChannel="cmafChannel" @changedCallback="updateCallback" :currentTab="currentTab"></tab-callback>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'chatting')}"  id="chatting-tab" role="tabpanel" aria-labelledby="chatting-tab" v-if="chattingAvailable">
                            <tab-chatting :channel="channel" :isExclusivePlayer="isExclusivePlayer" :modifyMode="modifyMode" @changedChatting="updateChatting" :currentTab="currentTab"></tab-chatting>
                        </div>
                        <div :class="{'tab-pane':true, 'active': (currentTab === 'referer')}"  id="referer-tab" role="tabpanel" aria-labelledby="referer-tab">
                            <tab-referer :channel="channel" :modifyMode="modifyMode" @changedReferer="updateReferer" :currentTab="currentTab"></tab-referer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import ChannelStatusMixin from '../../mixin/ChannelStatusMixin';
import TabCreator from './TabCreator.vue';
import TabSyndication from './TabSyndication.vue';
import TabFileTransfer from './TabFileTransfer.vue';
import TabCountryRestriction from './TabCountryRestriction.vue';
import TabDecoration from './TabDecoration.vue';
import TabCallback from './TabCallback.vue';
import TabChatting from './TabChatting.vue';
import TabReferer from './TabRefererCheck.vue';
import ChannelConfig from './ChannelConfig';

const CONCURRENTLY_VIEWER_LIMIT_START = -100;
const CONCURRENTLY_VIEWER_LIMIT_END = 1100;
const CONCURRENTLY_VIEWER_LIMIT_STEP = 100;

export default {
    mixins: [
        GlobalConfigMixin,
        ChannelStatusMixin,
    ],
    components: {
        'tab-creator': TabCreator,
        'tab-file_transfer': TabFileTransfer,
        'tab-syndication': TabSyndication,
        'tab-country_restriction': TabCountryRestriction,
        'tab-decoration': TabDecoration,
        'tab-callback': TabCallback,
        'tab-chatting': TabChatting,
        'tab-referer': TabReferer,
    },
    data() {
        return {
            editor: 'new',
            channel: {
                is_shared: true,
                // media_player_policy: 0,
                use_duplicate_block: false,
                use_capture_block: false,
                recording_file_policy: 2,
                use_timeshift: false,
                use_third_party_drm: false,
                widevine_revoked_device_play: true,
                max_age: 2,
                chunk_duration: 5,
                chunk_count: 4,
                use_aes128: false,
                disable_tvout: false,
            },
            channel_before_edit: {},
            meta: {
                errors: {},
            },
            currentTab: '',
            concurrently_viewer_limits: _.range(CONCURRENTLY_VIEWER_LIMIT_START, CONCURRENTLY_VIEWER_LIMIT_END, CONCURRENTLY_VIEWER_LIMIT_STEP),
            division_delayed_minutes: 3,
            division_delayed_minutes_limit: [0, 1, 2, 3, 4, 5],
            recording_file_segment_by_duration: 60,
            recording_file_segment_by_duration_limit: [10, 20, 30, 40, 50, 60, 120],
            media_profile_groups: {},
            recording_file_policy_manual: false,
            recording_file_policy_auto: false,
            firstRender: true,
        };
    },
    beforeMount() {
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }

        $('#childTab').tab();
        $('#childTab a[data-toggle="tab"]').on('show.bs.tab', () => this.$toasted.clear());
    },
    methods: {
        initialize() {
            this.global_reload_path = 'cms-channels-list';
            this.getChannel();
        },
        getRecordingFilePolicy() {
            this.recording_file_policy_auto = this.saveFileByAuto;
            this.recording_file_policy_manual = this.saveFileByManual;
        },
        setRecordingFilePolicy() {
            // 편성 채널일 경우 녹화파일을 생성하지 않는다.
            if (this.programChannel) {
                this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.NONE;
                return;
            }
            // if (this.webrtcChannel) {
            //     this.recording_file_policy_manual = false;
            // }
            if (this.recording_file_policy_auto && this.recording_file_policy_manual) {
                this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.BOTH;
            } else if (this.recording_file_policy_auto && !this.recording_file_policy_manual) {
                this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.ONLY_AUTO;
            } else if (!this.recording_file_policy_auto && this.recording_file_policy_manual) {
                this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.ONLY_MANUAL;
            } else {
                this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.NONE;
            }
        },
        getChannel() {
            if (typeof this.$route.params.channel_id !== 'undefined') {
                axios.get(`${this.channelApiUri}/${this.$route.params.channel_id}`).then((response) => {
                    this.editor = 'edit';
                    this.channel = response.data.data;
                    this.channel_before_edit = _.cloneDeep(this.channel);
                    this.getMediaProfileGroups(this.channel.kind);
                    this.getRecordingFilePolicy();
                }).catch((error) => {
                    // TODO error modal
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.channel_info'));
                    console.log(this.meta.errors);
                }).finally(() => {
                    this.firstRender = false;
                });
            } else {
                // Create Or Find Temporary Channel
                axios.post(this.channelApiUri).then((response) => {
                    this.channel = response.data.data;
                    this.getMediaProfileGroups(ChannelConfig.CHANNEL_KIND.GENERAL);

                    this.getRecordingFilePolicy();
                }).catch((error) => {
                    // TODO error modal
                    if (typeof error.response.data.errors === 'undefined' &&
                        typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message, { position: 'top-center', duration: 3000 });
                    } else {
                        this.meta.errors = error.response.data.errors;
                        this.$toasted.error(this.$t('paragraphs.message.error.channel_info'));
                    }
                }).finally(() => {
                    this.firstRender = false;
                });
            }
        },
        getMediaProfileGroups(channelKind) {
            let groupType = ChannelConfig.PROFILE_GROUP_TYPE.NORMAL;
            if (channelKind === ChannelConfig.CHANNEL_KIND.WEBRTC) {
                groupType = ChannelConfig.PROFILE_GROUP_TYPE.WEBRTC;
            }
            axios.get(`/cms/${this.selectedServiceAccount.key}/profile_groups?group_type=${groupType}`)
                .then((response) => {
                    this.media_profile_groups = response.data.data;
                    const self = this;
                    const findIdx = _.findIndex(this.media_profile_groups, item => item.id === self.channel.live_media_profile_group_id);
                    if (findIdx === -1) {
                        this.channel.live_media_profile_group_id = this.media_profile_groups[0].id;
                    }
                }).catch((error) => {
                    // TODO error modal
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.channel_encoding_info'));
                    console.log(this.meta.errors);
                });
        },
        doSubmit() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }
            let confirmMessage;
            if (this.modifyMode) {
                confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            } else {
                confirmMessage = this.$t('paragraphs.message.confirm.create_item');
            }
            if (this.channel.media_player_policy === 0) {
                this.channel.use_capture_block = false;
                // 전용 플레이어 사용하지 않을 때도 중복재생 차단 가능하도록 수정
                // this.channel.use_duplicate_block = false;
            }
            this.setRecordingFilePolicy();
            if (confirm(confirmMessage)) {
                const pickedKeys = [
                    'title',
                    'customer_code',
                    'concurrently_viewer_limit',
                    'live_media_profile_group_id',
                    'kind',
                    'is_shared',
                    'use_duplicate_block',
                    'meta_title_pattern',
                    'meta_description',
                    'recording_file_pattern',
                    'recording_file_policy',
                    'use_capture_block',
                    'media_player_policy',
                    'use_timeshift',
                    'division_delayed_minutes',
                    'use_third_party_drm',
                    'widevine_revoked_device_play',
                    'max_age',
                    'chunk_duration',
                    'chunk_count',
                    'chunk_count_cmaf',
                    'chunk_duration_cmaf',
                    'chunk_part_duration_cmaf',
                    'use_aes128',
                    'disable_tvout',
                ];

                if (this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.ONLY_AUTO ||
                    this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.BOTH) {
                    pickedKeys.push('recording_file_segment_policy');
                    pickedKeys.push('recording_file_segment_by_duration');
                }
                axios.put(`${this.channelApiUri}/${this.channel.id}`, _.pick(this.channel, pickedKeys)).then(() => {
                    if (this.modifyMode) {
                        this.$toasted.success(this.$t('paragraphs.message.success.update'));
                    } else {
                        // initialize channel's list query
                        localStorage.setItem('query', '');
                        this.$toasted.success(this.$t('paragraphs.message.success.create'));
                    }
                    this.$router.push({ name: 'cms-channels-list' });
                }).catch((error) => {
                    if (typeof error.response.data.errors === 'undefined' &&
                        typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message, { position: 'top-center', duration: 3000 });
                        return;
                    }

                    this.meta.errors = error.response.data.errors;

                    if (this.modifyMode) {
                        this.$toasted.error(this.$t('paragraphs.message.error.update'));
                    } else {
                        this.$toasted.error(this.$t('paragraphs.message.error.create'));
                    }
                });
            }
        },
        updateCallback(data) {
            this.channel.use_broadcast_update_callback = data.use_broadcast_update_callback;
            this.channel.broadcast_update_callback_url = data.broadcast_update_callback_url;
            this.channel.use_recording_file_transfer_callback = data.use_recording_file_transfer_callback;
            this.channel.recording_file_transfer_callback_url = data.recording_file_transfer_callback_url;
        },
        updateChatting(data) {
            this.channel.use_chatting_service = data.use_chatting_service;
            this.channel.chatting_service = data.chatting_service;
            this.channel.chatting_info = data.chatting_info;
            this.channel.chatting_position = data.chatting_position;
            this.channel.concurrently_chatting_limit = data.concurrently_chatting_limit;
            this.channel.chatting_scalable = data.chatting_scalable;
        },
        updateReferer(data) {
            this.channel.use_referer_check = data.use_referer_check;
            this.channel.referer_check_domains = data.referer_check_domains;
            this.channel.referer_reject_domains = data.referer_reject_domains;
        },
        isNotDigitOnly(data) {
            const regExp = /[^0-9]/g;
            return regExp.test(data);
        },
        isZero(data) {
            return data === 0 || data === '0';
        },
        checkDigitOnly(data) {
            if (this.isNotDigitOnly(data) || data === '') {
                return '';
            }
            return Number(data);
        },
        checkDigitOnlyAndNotZero(data) {
            if (this.isNotDigitOnly(data) || this.isZero(data) || data === '') {
                return '';
            }
            return Number(data);
        },
        disablePassThrough(profiles) {
            const isPassThrough = profiles.some(profile => profile.key === 'passthrough');
            return this.channel.kind === ChannelConfig.CHANNEL_KIND.CMAF && isPassThrough;
        },
    },
    computed: {
        channelApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels`;
        },
        isExclusivePlayer() {
            return this.useExclusivePlayerPolicy &&
                (this.channel.media_player_policy === 1 || this.channel.media_player_policy === 2);
        },
        isUsingMultiDrm() {
            return this.useThirdPartyDrmPolicy && this.channel.use_third_party_drm;
        },
        isOnAir() {
            return this.editor === 'edit' && typeof this.channel.latest_live_media_broadcast.is_onair === 'boolean' &&
                this.channel.latest_live_media_broadcast.is_onair;
        },
        modifyMode() {
            return this.$route.name === 'cms-channels-edit';
        },
        saveFileByAuto() {
            return this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.ONLY_AUTO
                || this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.BOTH;
        },
        saveFileByManual() {
            return this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.ONLY_MANUAL
                || this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.BOTH;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        isCmafChannel() {
            return this.channel.kind === ChannelConfig.CHANNEL_KIND.CMAF;
        },
        supportMailData() {
            const text = this.$t('paragraphs.not_use_aes128');
            const beforeSupportMailIndex = text.indexOf(',');
            const splitTextIndex = text.indexOf(')');

            return {
                before: text.substring(0, beforeSupportMailIndex + 1),
                email: text.substring(beforeSupportMailIndex + 1, splitTextIndex).trim(),
                after: text.substring(splitTextIndex),
            };
        },
        supportMailHtml() {
            const { before, email, after } = this.supportMailData;
            const emailHtml = `<a href="mailto:${email}" style="color: unset; text-decoration: underline;">${email}</a>`;
            return `${before} ${emailHtml}${after}`;
        },
        isMultiDrmDisabled() {
            return this.channel.use_aes128;
        },
        isCaptureBlockDisabled() {
            return this.channel.media_player_policy === 0;
        },
        isMultiDrmUsed() {
            return this.channel.use_third_party_drm;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        // program channel일 경우 녹화파일 저장하지 않음.
        // 방송 제목 패턴 : 프로그램 제목으로 한다.
        'channel.kind': {
            handler(newValue, oldValue) {
                console.log('kind changed', oldValue, newValue);
                if (typeof oldValue !== 'undefined' && oldValue !== ChannelConfig.CHANNEL_KIND.PROGRAMMING && newValue === ChannelConfig.CHANNEL_KIND.PROGRAMMING) {
                    this.channel.recording_file_policy = ChannelConfig.RECORDING_FILE_POLICY.NONE;
                    this.channel.meta_title_pattern = '[PROGRAM_TITLE]';
                }

                // 채널타입에 따라 서로 다른 탭항목 활성화.
                // const targetTab = (newValue === ChannelConfig.CHANNEL_KIND.GENERAL || newValue === ChannelConfig.CHANNEL_KIND.WEBRTC) ? '#creater-nav' : '#syndication-nav';
                this.currentTab = (newValue === ChannelConfig.CHANNEL_KIND.GENERAL || newValue === ChannelConfig.CHANNEL_KIND.WEBRTC || newValue === ChannelConfig.CHANNEL_KIND.CMAF) ? 'creator' : 'syndication';
                // document.querySelector(targetTab).click();

                if (typeof oldValue !== 'undefined' && oldValue !== newValue) {
                    this.getMediaProfileGroups(newValue);
                }
                if (newValue === ChannelConfig.CHANNEL_KIND.WEBRTC) { // webrtc 채널은 수동녹화를 사용하지 않는다.
                    // this.channel.division_delayed_minutes = 0;
                    this.channel.media_player_policy = 0;
                    this.channel.use_duplicate_block = false;
                    // this.recording_file_policy_manual = false;
                    this.channel.use_timeshift = false;
                }
                if (typeof oldValue !== 'undefined' && newValue === ChannelConfig.CHANNEL_KIND.CMAF) {
                    this.channel.max_age = 2;
                    this.channel.chunk_duration = 5000;
                    this.channel.chunk_count = 4;
                    this.channel.chunk_part_duration_cmaf = 1000;
                    this.channel.chunk_duration_cmaf = 2000;
                    this.channel.chunk_count_cmaf = 4;
                    const selectedProfile = this.media_profile_groups.find(group => group.id === this.channel.live_media_profile_group_id);
                    if (selectedProfile.name === 'Passthrough - Landscape') {
                        const defaultProfile = this.media_profile_groups.find(group => group.name === 'Default - landscape');
                        if (defaultProfile) {
                            this.$toasted.success(this.$t('paragraphs.channel.profile_changed'));
                            this.channel.live_media_profile_group_id = defaultProfile.id;
                        }
                    }
                    if (selectedProfile.name === 'Passthrough - Portrait') {
                        const defaultProfile = this.media_profile_groups.find(group => group.name === 'Default - portrait');
                        if (defaultProfile) {
                            this.$toasted.success(this.$t('paragraphs.channel.profile_changed'));
                            this.channel.live_media_profile_group_id = defaultProfile.id;
                        }
                    }
                }
                if (typeof oldValue !== 'undefined' && newValue !== ChannelConfig.CHANNEL_KIND.CMAF && oldValue === ChannelConfig.CHANNEL_KIND.CMAF) {
                    this.channel.chunk_part_duration_cmaf = 0;
                }
            },
            deep: true,
        },
        'channel.use_aes128': {
            handler(use_aes128) {
                const isUsingMultiDrm = this.useThirdPartyDrmPolicy && !this.webrtcChannel;
                if (use_aes128 && !this.firstRender && isUsingMultiDrm) {
                    this.channel.use_third_party_drm = false;
                    this.$toasted.success(this.$t('paragraphs.channel.multi_drm_changed'));
                }
            },
        },
    },
};
</script>

<style scoped>
.form__select--sm {
    width: auto;
}

.input-group input:has(+ div.input-group-append):not(.is-invalid) {
    border-right: 0;
}

.input-group input + .input-group-append .input-group-text {
    background-color: inherit;
    border-radius: 3px;
}

.form-control:disabled + .input-group-append {
    background-color: #e9ecef;
    opacity: 1;
}
</style>
